import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CongresVirtuelMainComponent } from './congres-virtuel-main/congres-virtuel-main.component';
import { CongresVirtuelMotpresidentComponent } from './congres-virtuel-motpresident/congres-virtuel-motpresident.component';
import { CongresVirtuelAproposComponent } from './congres-virtuel-apropos/congres-virtuel-apropos.component';
import { CongresVirtuelAccreditationComponent } from './congres-virtuel-accreditation/congres-virtuel-accreditation.component';
import { CongresVirtuelComitesComponent } from './congres-virtuel-comites/congres-virtuel-comites.component';
import { CongresVirtuelAuthComponent } from './congres-virtuel-auth/congres-virtuel-auth.component';
import { NotLoggedInCongresService } from './Services/not-logged-in-congres.service';
import { CongresVirtuelProgrammeComponent } from './congres-virtuel-programme/congres-virtuel-programme.component';
import { CongresVirtuelChangePassComponent } from './congres-virtuel-change-pass/congres-virtuel-change-pass.component';
import { CongresVirtuelIndustrieComponent } from './congres-virtuel-industrie/congres-virtuel-industrie.component';
import { CongresVirtuelMentionsLegalesComponent } from './congres-virtuel-mentions-legales/congres-virtuel-mentions-legales.component';
import { CongresVirtuelLoginBackdoorComponent } from './congres-virtuel-login-backdoor/congres-virtuel-login-backdoor.component';
import { CongresVirtuelComponent } from './congres-virtuel/congres-virtuel.component';
import { LoggedInCongresService } from './Services/logged-in-congres.service';
import { CongresWelcomeComponent } from './congres-welcome/congres-welcome.component';
import { CongresVirtuelConferencesComponent } from './congres-virtuel-conferences/congres-virtuel-conferences.component';
import { CongresVirtuelEpostersComponent } from './congres-virtuel-eposters/congres-virtuel-eposters.component';
import { CongresVisitingComponent } from './congres-visiting/congres-visiting.component';
import { HallOneComponent } from './hall-one/hall-one.component';
import { HallTwoComponent } from './hall-two/hall-two.component';
import { StandVisitingComponent } from './stand-visiting/stand-visiting.component';
import { CongresVirtuelManagerComponent } from './congres-virtuel-manager/congres-virtuel-manager.component';
import { CongresVirtuelManagerStandComponent } from './congres-virtuel-manager-stand/congres-virtuel-manager-stand.component';


const routes: Routes = [
  { path: 'congres-virtuel-main', component: CongresVirtuelMainComponent},
  { path: 'congres-virtuel-mot-du-president', component: CongresVirtuelMotpresidentComponent},
  { path: 'congres-virtuel-apropos', component: CongresVirtuelAproposComponent},
  { path: 'congres-virtuel-accreditation', component: CongresVirtuelAccreditationComponent},
  { path: 'congres-virtuel-comites', component: CongresVirtuelComitesComponent},
  { path: 'congres-virtuel/auth/change-pass', component: CongresVirtuelChangePassComponent, canActivate:[NotLoggedInCongresService]},  
  { path: 'congres-virtuel/auth', component: CongresVirtuelAuthComponent, canActivate:[NotLoggedInCongresService]}, 
  { path: 'congres-virtuel-programme', component: CongresVirtuelProgrammeComponent},  
  { path: 'congres-virtuel-industrie', component: CongresVirtuelIndustrieComponent},
  { path: 'congres-virtuel-mentions-legales', component: CongresVirtuelMentionsLegalesComponent},
  { path: 'congres-virtuel-login-backdoor', component: CongresVirtuelLoginBackdoorComponent},
  { path: 'congres-virtuel-vc-manager', component: CongresVirtuelManagerComponent},
  { path: 'congres-virtuel-vc-manager/stand/:id', component: CongresVirtuelManagerStandComponent},
  /*{ path: 'congres-virtuel', component: CongresVirtuelComponent, canActivate:[LoggedInCongresService], 
  children: [
    { path: 'welcome', component: CongresWelcomeComponent},
    { path: 'conferences', component: CongresVirtuelConferencesComponent},
    { path: 'eposters', component: CongresVirtuelEpostersComponent},
    { path: 'visiting', component: CongresVisitingComponent},
    { path: 'hall-one', component: HallOneComponent},
    { path: 'hall-two', component: HallTwoComponent},
    { path: 'stand-visiting/:id', component: StandVisitingComponent},
    { path: '', redirectTo: 'welcome', pathMatch: 'full' },
    { path: '**', redirectTo: 'welcome', pathMatch: 'full' },
  ]},*/
  { path: '', redirectTo: '/congres-virtuel-main', pathMatch: 'full' },
  { path: '**', redirectTo: '/congres-virtuel-main', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
